import { useNavigate } from 'react-router-dom';
import { useTenantStore } from '@/store/tenantStore';
import { useIsMobile } from '@/hooks/useMediaQuery';
import { getAuthLogoUrl, getLogoImageSize } from '@/services/tenant/tenantImages';
import { analyticsService } from '@/services/analytics/analyticsService';
import { ROUTES } from '@/app/router/routes';
import styles from '../AuthPage.module.css';

/**
 * AuthLogo — the tenant logo at the top right of the auth forms, desktop only.
 *
 * Mirrors the logo block in Flutter web_login_forms.dart, web_signup_page.dart,
 * verify_acc_card.dart, web_forgot_password.dart and web_email_based_mfa_otp_widget.dart:
 * shown when general.authenticationLogoConfig.showLogo is true, white or colored by logoType,
 * sized like NetworkImageConstant.logoImageHeight/Width; tapping it goes home.
 */
export function AuthLogo() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { content } = useTenantStore();

  const url = getAuthLogoUrl(content);
  if (isMobile || !url) return null;

  const size = getLogoImageSize(content);
  const brandName = content?.contentSettings?.general?.name ?? '';

  return (
    <div className={styles.authLogo}>
      <button
        type="button"
        className={styles.authLogoBtn}
        onClick={() => {
          void analyticsService.logScreenView({ screenName: ROUTES.HOME });
          navigate(ROUTES.HOME, { replace: true });
        }}
      >
        <img src={url} alt={brandName} className={styles.authLogoImage} style={size} />
      </button>
    </div>
  );
}
